import { render, staticRenderFns } from "./PartnerWarning.vue?vue&type=template&id=27662d20"
import script from "./PartnerWarning.vue?vue&type=script&lang=js"
export * from "./PartnerWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports